import { registerComponent } from '@gig/magic-common';
import PeriodicAccountReviewModalComponent from './periodic-account-review-modal.vue.js';

var PeriodicAccountReviewModal = registerComponent(PeriodicAccountReviewModalComponent);

export { PeriodicAccountReviewModal };
